import { SubmitEvent } from "react";

import { useTranslation } from "react-i18next";

import { BorderFrame } from "../components/BorderFrame";
import { Buttons } from "../components/Buttons";
import { InnerTop } from "../components/InnerTop";

export interface SuccessMessageProps {
  closeScreen: () => void;
}

const SuccessMessage = ({ closeScreen }: SuccessMessageProps) => {
  const { t } = useTranslation();

  const handleSubmit = (e: SubmitEvent<HTMLFormElement>) => {
    e.preventDefault();
    closeScreen();
  };

  return (
    <form onSubmit={handleSubmit}>
      <BorderFrame>
        <InnerTop
          title={t("Security##2FA##success message##title")}
          description={t("Security##2FA##success message##description")}
        />
      </BorderFrame>

      <Buttons
        isPrimaryBtnDisabled={false}
        primaryBtnTitle={t("Button##open TachoSync")}
      />
    </form>
  );
};

export { SuccessMessage };
